import { render, staticRenderFns } from "./Gravacao.vue?vue&type=template&id=7d63bd20&"
import script from "./Gravacao.vue?vue&type=script&lang=js&"
export * from "./Gravacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports